import React, { createContext, useState, useCallback, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import UserService from '../../services/User/User.service'
import PropTypes from 'prop-types'

export const CurrentUserContext = createContext()

export const CurrentUserContextProvider = (props) => {
  const [me, setMe] = useState(null)
  const [portals, setPortals] = useState(null)

  const formatAllPortals = (allPortals) => {
    if (!allPortals) {
      return
    }
    const formattedPortals = []
    allPortals.forEach((portal) => {
      formattedPortals.push(portal)
      portal.subPortals?.forEach((subportal) => {
        formattedPortals.push(subportal)
      })
    })

    formattedPortals.sort((a, b) => a.name.localeCompare(b.name))

    return formattedPortals
  }

  const fetchMe = useCallback(async () => {
    UserService.fetchMe()
      .then((response) => {
        if (response.data) {
          setMe(response.data.user)
          setPortals(formatAllPortals(response.data.portals))
          if (response.data.user) {
            Sentry.setUser({ id: response.data.user.id, email: response.data.user.email })
          }
        }
      })
      .catch((_) => {
        // Error fetching me
      })
  }, [])

  useEffect(() => {
    let isMounted = true

    UserService.fetchMe()
      .then((response) => {
        if (isMounted && response.data) {
          setMe(response.data.user)
          setPortals(formatAllPortals(response.data.portals))
          if (response.data.user) {
            Sentry.setUser({ id: response.data.user.id, email: response.data.user.email })
          }
        }
      })
      .catch((error) => {
        // Only log unexpected errors (not 401/403 which are expected when not authenticated)
        if (isMounted && error?.response?.status !== 401 && error?.response?.status !== 403) {
          console.log('Error fetching me:', error)
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <CurrentUserContext.Provider value={{ me, fetchMe, portals }}>
      {props.children}
    </CurrentUserContext.Provider>
  )
}

CurrentUserContextProvider.propTypes = {
  children: PropTypes.object
}
